export default __webpack_public_path__ + "static/boticario-e6be06f51981baa9390a0ab8f1084a74.png";